/**
 * The famous compose function
 *
 * @param {...Function} functions - the functions to be composed
 * @see https://github.com/acdlite/recompose/blob/master/src/packages/recompose/compose.js
 */
export default (...funcs) =>
  funcs.reduce(
    (a, b) => (...args) => a(b(...args)),
    arg => arg
  )
